
export const profiloSelector = (state) => state.profilazione.profilo;

export const postProfiloSelector = (state) => state.profilazione.postProfilo;

export const presaVisioneSelector = (state) => state.profilazione.presaVisione;

export const informativaPrivacySelector = (state) => state.profilazione.informativaPrivacy;

export const avvisiUtenteSelector = (state) => state.profilazione.avvisiUtente;